export const PORT = window.location.port;
// export const PORT = 3000;

// Homelab patch: when served behind a TLS reverse proxy on the default port,
// window.location.port is "" — emit "host" not "host:" so the URLs stay valid.
const portSuffix = PORT ? `:${PORT}` : "";

export const WEB_SOCKET_RELAY_URL = `${
  window.location.protocol === "https:" ? "wss:" : "ws:"
}//${window.location.hostname}${portSuffix}`;
export const HTTP_RELAY_URL = `${window.location.protocol}//${window.location.hostname}${portSuffix}`;
export const RELAY_PROXY_URL = `${window.location.protocol}//${window.location.hostname}${portSuffix}/relay-proxy`;
